import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/salary-rules-v2")({
  component: () => <Outlet />,
});
